import { Flex } from "@chakra-ui/react"

export const Anchor = ({id} : {id: string}) => {
    return <Flex pos="absolute" id={id} top="-100px"></Flex>
}